import React from "react";
import Icon from "@ant-design/icons";
import instaIcon from "../../../assets/Svg/insta.png";
const InstaImg = () => <img src={instaIcon} alt="" />;

const InstaIcon = (props) => <Icon component={InstaImg} {...props} />;

export default InstaIcon;
